import {
  usePaywallCheckoutContext,
  type CheckoutContextProps,
} from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { createContext, useContext } from "react";
import type { PropsWithChildren } from "react";
import invariant from "tiny-invariant";

type PricePreviewCheckoutProvider = Pick<
  CheckoutContextProps,
  "previewMutation" | "hasAlreadyPurchased" | "paywall"
>;

interface PricePreviewProviderProps {
  useHooks: () => PricePreviewCheckoutProvider;
}

const PricePreviewProvider = createContext<PricePreviewProviderProps | null>(
  null,
);

PricePreviewProvider.displayName = "PricePreviewProvider";

export const usePricePreviewContext = () => {
  const context = useContext(PricePreviewProvider);

  invariant(
    context,
    "usePricePreviewContext must be used within a PricePreviewContext.Provider",
  );

  return context.useHooks();
};

interface PricePreviewContextProps {
  useHooks?: () => PricePreviewCheckoutProvider;
}

export const PricePreviewContext = ({
  children,
  useHooks = usePaywallCheckoutContext,
}: PropsWithChildren<PricePreviewContextProps>) => (
  <PricePreviewProvider.Provider value={{ useHooks }}>
    {children}
  </PricePreviewProvider.Provider>
);
